// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".contact-form__container[data-v-4c2d8a3b]{max-width:49.375rem}@media only screen and (min-width:960px){.contact-form__container[data-v-4c2d8a3b]{padding:0!important}}.contact-form__form[data-v-4c2d8a3b]{display:grid;grid-gap:1.5rem;gap:1.5rem}.contact-form__button[data-v-4c2d8a3b]{justify-self:start}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
